import React, { Component } from "react";
import LoaderButton from "./LoaderButton";
import intl from "react-intl-universal";

class LogOut extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false
    };
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isLoading: true });

    fetch(process.env.REACT_APP_API_URL + "logout", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({})
    })
      .then(res => res.json())
      .then(result => {
        if (result.Result === "Success") {
          this.props.props.userHasAuthenticated(false, undefined);
        }
        this.setState({ isLoading: false });
      })
      .catch(error => {
        console.error(error);
        this.props.props.handleServerError(true);
      });
  };

  render() {
    return (
      <LoaderButton
        className="accountLinks"
        type="button"
        isLoading={this.state.isLoading}
        onClick={this.handleSubmit}
        text={intl.get("Log_Out")}
        loadingText="Logging out…"
      />
    );
  }
}

export default LogOut;
